var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wbench-process-child"},[_c('div',{staticClass:"child-box",attrs:{"id":"wbenchPrintBox"}},[_c('img',{staticClass:"flow-image",attrs:{"src":_vm.imgUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }